/**
 * @fileoverview GET handler for the "/api/ecommerce/event_properties" endpoint
 */
/**
 * @owner @Appboy/user-targeting
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiEcommerceEventProperties } from "./constants";
import type { EcommerceEventPropertiesErrors, EcommerceEventPropertiesResponse } from "./types";

export const getApiEcommerceEventProperties = reactQueryFetcherAdapter(
  apiEcommerceEventProperties,
  createGetFetcherFunctionWithShadowError<EcommerceEventPropertiesErrors>()(
    (signal: AbortSignal, eventName: string): Promise<EcommerceEventPropertiesResponse> => {
      return fetch("/api/ecommerce/event_properties", "GET", { event_name: eventName }, { signal });
    }
  )
);
